import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import PatientFunctionsGetter from "../../Controller/getSQLPatientFunctions.js";
import UserFunctionsGetter from "../../Controller/getSQLUserFunctions.js";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import InvalidObject from '../Common/InvalidObject.js';
import AddPractitionerPopup from '../Correspondant/AddPractitionerPopup.js';
import axios from "axios";
import {FormattedMessage, useIntl} from 'react-intl';
import { userIsSuperAdmin } from '../../Controller/userRoles.js';

const AddUser = (props) => {
  const [user, setUser] = useState({id_user: props.id_user, user_mail: "", role: 0, FK_structure: 0});
  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");
  const [isBeingCreated, setIsBeingCreated] = useState(false);
  const [invalidObject, setInvalidObject] = useState(false);
  const [staffType, setStaffType] = useState("other");
  const [showPractitionerPopup, setShowPractitionerPopup] = useState(false);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const [sendInvitation, setSendInvitation] = useState(false);
  const [psadStructures, setPsadStructures] = useState([]);
  const [selectedPsadStructure, setSelectedPsadStructure] = useState("");
  const [psadAdmin, setPsadAdmin] = useState(false);
  const [emailHintVisible, setEmailHintVisible] = useState(false);

  const intl = useIntl();
  const isSuperAdmin = userIsSuperAdmin(props.accountInformation);

  useEffect(() => {
  }, []);

  useEffect(() => {
    const fetchPsadStructures = async () => {
      const structures = await PatientFunctionsGetter.get_structures_by_type('psad');
      setPsadStructures(structures || []);
    };

    fetchPsadStructures();
  }, []);

  // When PSAD is selected, default the structure to the one the action originated from
  useEffect(() => {
    if (staffType === "psad" && !selectedPsadStructure && props.targetStructureId &&
        psadStructures.some(s => s.id_structure === props.targetStructureId)) {
      setSelectedPsadStructure(props.targetStructureId);
    }
  }, [staffType, psadStructures, props.targetStructureId, selectedPsadStructure]);

  const isValidEmail = (email) => {
    const trimmedEmail = (email || "").trim();
    const checkExp = new RegExp('^[a-z0-9]+([_|\\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\\.|-]{1}[a-z0-9]+)*[\\.]{1}[a-z]{2,6}$', 'i');
    return checkExp.test(trimmedEmail);
  };

  const hasValidEmail = isValidEmail(user.user_mail);

  useEffect(() => {
    if (!hasValidEmail && sendInvitation) {
      setSendInvitation(false);
    }
    if (hasValidEmail) setEmailHintVisible(false);
  }, [hasValidEmail, sendInvitation]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const handleStaffTypeChange = (type) => {
    setStaffType(type);
    if (type !== "practitioner") {
      setSelectedPractitioner(null);
      setShowPractitionerPopup(false);
    }
    if (type !== "psad") {
      setSelectedPsadStructure("");
      setPsadAdmin(false);
    }
  };

  const cancelInvalidObjectPopup = () => {
    setInvalidObject(false);
  }

  const getRequestErrorMessage = (error) => {
    if (error && error.response && error.response.data) {
      if (typeof(error.response.data) === "string") {
        return error.response.data;
      }
      return JSON.stringify(error.response.data);
    }
    if (error && error.message) {
      return error.message;
    }
    return "";
  }

  const getTranslatedErrorMessage = (errorMessage) => {
    if (!errorMessage) {
      return <FormattedMessage id="message.error.addstaff" defaultMessage="Oops, that didn't work... (err_code addstaff)" />;
    }
    if (errorMessage.includes("User already exist")) {
      return <FormattedMessage id="message.error.userAlreadyExists" defaultMessage="User already exists" />;
    }
    if (errorMessage.includes("Failed to save practitioner") || errorMessage.includes("Error saving practitioner")) {
      return <FormattedMessage id="practitioner.manual.saveError" defaultMessage="Error saving practitioner" />;
    }
    if (errorMessage.includes("Can't create user in local database")) {
      return <FormattedMessage id="staff.error.localDatabase" defaultMessage="Unable to create the user in the local database" />;
    }
    if (errorMessage.includes("Can't create user in Keycloak") || errorMessage.includes("Keycloak user creation error") || errorMessage.includes("Keycloak admin token error") || errorMessage.includes("Keycloak user search error")) {
      return <FormattedMessage id="staff.error.identityProvider" defaultMessage="Unable to create the user account" />;
    }
    if (errorMessage.includes("Missing practitioner identifier or email")) {
      return <FormattedMessage id="staff.error.missingPractitionerIdentifier" defaultMessage="Practitioner email or identifier is missing" />;
    }
    if (errorMessage.includes("Wrong user rights")) {
      return <FormattedMessage id="staff.error.forbidden" defaultMessage="You do not have permission to add a staff member" />;
    }
    if (errorMessage.includes("invalid fhir request") || errorMessage.includes("Create practitioner parameters not validated")) {
      return <FormattedMessage id="staff.error.invalidPractitionerRequest" defaultMessage="The practitioner data is invalid" />;
    }
    return <FormattedMessage id="message.error.addstaff" defaultMessage="Oops, that didn't work... (err_code addstaff)" />;
  }

  const handlePractitionerSelect = (practitioner) => {
    setShowPractitionerPopup(false);
    setSelectedPractitioner(practitioner);
    setUser((prev) => ({ ...prev, user_mail: practitioner.msmail || practitioner.mssante_email || practitioner.email || prev.user_mail || "" }));
  };


  const saveUser = async () => {
    if (staffType === "practitioner" && !showPractitionerPopup && !selectedPractitioner) {
      setShowPractitionerPopup(true);
      return;
    }

    if (staffType === "psad" && isSuperAdmin && !selectedPsadStructure) {
      setmessage(<FormattedMessage id="patient.selectStructure" defaultMessage="-- Select a structure --" />);
      setInvalidObject(true);
      return;
    }

    if(hasValidEmail){

        const targetStructureId = staffType === "psad"
          ? (isSuperAdmin ? selectedPsadStructure : (props.targetStructureId || undefined))
          : (props.targetStructureId || undefined);

        setmessage(<FormattedMessage id="staff.creation" defaultMessage="Staff creation, please wait..." />)
        setIsBeingCreated(true);

        //TMP: should be replaced by invitation
        var data_create = {
          "resourceType" : "Practitioner",
          "identifier" : {
            "value" : user.user_mail
          },
          "name" : [{
            "use" : "official",
            "family" : "Practitionner",
            "given" : ["New"]
          }],
          "telecom":{
            "system":"email",
            "value":user.user_mail
          },
          "send_invitation": sendInvitation,
          "language": intl.locale
        }
        var data_update = {
          "resourceType" : "Practitioner",
          // A PSAD admin is a full admin of its (PSAD) structure: role='admin' so it is
          // picked up by GetAdminsFromStructure (WHERE role='admin') and therefore sees
          // the structure's patients. PSAD-ness itself comes from the structure type;
          // role_extra='admin_psad' is kept only as a marker (consistent with existing rows).
          "role": staffType === "psad" || staffType === "practitioner" ? "admin" : (props.role || "staff"),
          "role_extra": (staffType === "psad" && psadAdmin) ? "admin_psad" : undefined,
          "FK_structure": targetStructureId,
          "profession": (selectedPractitioner && selectedPractitioner.profession)
            ? selectedPractitioner.profession
            : (staffType !== "other" ? staffType : undefined),
          "rpps_data": selectedPractitioner ? {
            rpps:              selectedPractitioner.rpps || null,
            family:            selectedPractitioner.family || null,
            given:             selectedPractitioner.given || null,
            profession:        selectedPractitioner.profession || null,
            category:          selectedPractitioner.category || null,
            msmail:            selectedPractitioner.msmail || null,
            organization_name: selectedPractitioner.organization_name || null,
            finess:            selectedPractitioner.finess || null,
            siret:             selectedPractitioner.siret || null,
            address_line1:     selectedPractitioner.address_line1 || null,
            address_line2:     selectedPractitioner.address_line2 || null,
            postal_code:       selectedPractitioner.postal_code || null,
            city:              selectedPractitioner.city || null,
            country:           selectedPractitioner.country || null,
            phone:             selectedPractitioner.phone || null,
            email:             selectedPractitioner.email || null,
            mssante_email:     selectedPractitioner.mssante_email || selectedPractitioner.msmail || null,
            practice_mode:     selectedPractitioner.practice_mode || null,
            activity_sector:   selectedPractitioner.activity_sector || null,
            diplomas:          selectedPractitioner.diplomas || null,
            source: selectedPractitioner.source || {
              provider: "Annuaire Santé / RPPS",
              lastSyncAt: new Date().toISOString()
            }
          } : undefined
        }

        try {
          await DataServiceSQL.createUserReq_fhir(data_create);

          await DataServiceSQL.updatePractitionnerReq_fhir(user.user_mail, data_update);
          await UserFunctionsGetter.get_staff_user_list(props.structure_Id);

          setmessage(<FormattedMessage id="message.success" defaultMessage="Success !"/>);
          setsubmitted(true);
        }
        catch(e) {
          let errorMessage = getRequestErrorMessage(e);
          let translatedErrorMessage = getTranslatedErrorMessage(errorMessage);
          setmessage(
            <>
              <FormattedMessage id="message.error.addstaff" defaultMessage="Oups, did not work... (err_code addstaff)"/>
              {errorMessage !== "" ? <><br/><span style={{fontSize: "0.9em"}}>{translatedErrorMessage}</span></> : null}
            </>
          );
          setsubmitted(true);
        }
    }        
    else{
      setmessage(<FormattedMessage id="message.invalidMail" defaultMessage="Oups, did not work... (err_code addstaff)"/>);
      setInvalidObject(true);
    }
  };

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {(submitted) ? (
            <div>
              <center>
                <Row className="justify-content-md-end">
                  <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                    <FormattedMessage id="staff.add" defaultMessage="Add a caregiver"/>
                  </Col>
                </Row>
                <h4>{message}</h4>
                <button onClick={props.closeAfterAdd} className="btn btn-success">
                  <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) : (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end">
                    <Col style={{ fontWeight: "bold", fontSize:"2.0em" }}>
                      <FormattedMessage id="staff.add" defaultMessage="Add a caregiver" />
                    </Col>
                  </Row>
                </div>
                <br/>
                {isBeingCreated ?
                  <div>
                    <center>
                      <h4>{message}</h4>
                    </center>
                  </div>
                  :
                  <div>
                    <div className="form-group" style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "16px"}}>
                      <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                        <input
                          type="radio"
                          id="staff_type_other"
                          name="staff_type"
                          value="other"
                          checked={staffType === "other"}
                          onChange={() => handleStaffTypeChange("other")}
                        />
                        <label htmlFor="staff_type_other" style={{marginBottom: 0}}>
                          <FormattedMessage id="staff.type.other" defaultMessage="Staff" />
                        </label>
                      </div>
                      <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                        <input
                          type="radio"
                          id="staff_type_psad"
                          name="staff_type"
                          value="psad"
                          checked={staffType === "psad"}
                          onChange={() => handleStaffTypeChange("psad")}
                        />
                        <label htmlFor="staff_type_psad" style={{marginBottom: 0}}>
                          <FormattedMessage id="staff.type.psad" defaultMessage="Admin" />
                        </label>
                      </div>
                      {isSuperAdmin && (
                        <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                          <input
                            type="radio"
                            id="staff_type_practitioner"
                            name="staff_type"
                            value="practitioner"
                            checked={staffType === "practitioner"}
                            onChange={() => handleStaffTypeChange("practitioner")}
                          />
                          <label htmlFor="staff_type_practitioner" style={{marginBottom: 0}}>
                            <FormattedMessage id="staff.type.practitioner" defaultMessage="Practitioner" />
                          </label>
                        </div>
                      )}
                    </div>
                    {/* Practitioners are chosen through the RPPS/platform search, which also
                        supplies their email. Keep this action next to the type selection and
                        avoid presenting a second, conflicting email field. */}
                    {staffType === "practitioner" ? (
                      <div className="form-group" style={{maxWidth: "420px", margin: "12px auto 16px auto"}}>
                        {selectedPractitioner && (
                          <div style={{background: "#f0f8ff", border: "1px solid #b8daff", borderRadius: "4px", padding: "8px 12px", marginBottom: "8px", fontSize: "0.9em", textAlign: "left"}}>
                            <strong>{selectedPractitioner.family}{selectedPractitioner.given && selectedPractitioner.given.length > 0 ? `, ${Array.isArray(selectedPractitioner.given) ? selectedPractitioner.given.join(" ") : selectedPractitioner.given}` : ""}</strong>
                            {selectedPractitioner.rpps && <span style={{marginLeft: "8px", color: "#555"}}>RPPS: {selectedPractitioner.rpps}</span>}
                            {(selectedPractitioner.msmail || selectedPractitioner.mssante_email) && <span style={{marginLeft: "8px", color: "#555"}}>{selectedPractitioner.msmail || selectedPractitioner.mssante_email}</span>}
                          </div>
                        )}
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setShowPractitionerPopup(true)}
                        >
                          <FormattedMessage id="staff.practitioner.selectBtn" defaultMessage="Search or add a practitioner" />
                        </button>
                      </div>
                    ) : (
                      <div className="form-group" style={{maxWidth: "420px", margin: "16px auto", textAlign: "left"}}>
                        <label htmlFor="user_mail">
                          <FormattedMessage id="staff.mail" defaultMessage="Mail" />
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="user_mail"
                          required
                          value={user.user_mail}
                          onChange={handleInputChange}
                          name="user_mail"
                        />
                      </div>
                    )}
                    {staffType === "psad" && isSuperAdmin && (
                      <div className="form-group" style={{maxWidth: "420px", margin: "0 auto 16px auto", textAlign: "left"}}>
                        <label htmlFor="psad_structure">
                          <FormattedMessage id="patient.delegateStructureLabel" defaultMessage="Structure name" />
                        </label>
                        <select
                          id="psad_structure"
                          className="form-control"
                          value={selectedPsadStructure}
                          onChange={(e) => setSelectedPsadStructure(e.target.value)}
                        >
                          <option value="">{intl.formatMessage({ id: "patient.selectStructure", defaultMessage: "-- Select a structure --" })}</option>
                          {psadStructures.map((structure) => (
                            <option key={structure.id_structure} value={structure.id_structure}>
                              {structure.structure_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {staffType === "psad" && (
                      <div className="form-group" style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "8px"}}>
                        <input
                          type="checkbox"
                          id="psad_admin"
                          checked={psadAdmin}
                          onChange={(e) => setPsadAdmin(e.target.checked)}
                        />
                        <label htmlFor="psad_admin" style={{marginBottom: 0}}>
                          <FormattedMessage id="staff.psad.admin" defaultMessage="Définir comme administrateur principal PSAD" />
                        </label>
                      </div>
                    )}
                    <div onClick={() => { if (!hasValidEmail) setEmailHintVisible(true); }}>
                      <div className="form-group" style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "8px"}}>
                        <input
                          type="checkbox"
                          id="send_invitation"
                          checked={sendInvitation}
                          disabled={!hasValidEmail}
                          onChange={(e) => setSendInvitation(e.target.checked)}
                        />
                        <label htmlFor="send_invitation" style={{marginBottom: 0, cursor: !hasValidEmail ? 'not-allowed' : 'pointer'}}>
                          <FormattedMessage id="staff.send_invitation_mail" defaultMessage="Send welcome/signup email" />
                        </label>
                      </div>
                      {emailHintVisible && !hasValidEmail && (
                        <div style={{ color: '#dc3545', fontSize: '0.82em', textAlign: 'center', marginTop: -4 }}>
                          <FormattedMessage id="message.invalidMail" defaultMessage="Format email invalide" />
                        </div>
                      )}
                    </div>
                    <br/>
                    <div>
                      <button onClick={props.cancelPopup} className="btn btn-danger">
                        <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                      </button> 
                      <b>&emsp;</b>                                                                     
                      <button onClick={saveUser} className="btn btn-success">
                        <FormattedMessage id="button.submit" defaultMessage="Submit" />
                      </button>
                    </div>
                  </div>
                }
              </center>
            </div>
          )}
          <div>
            {invalidObject ?
              <InvalidObject cancelPopup={cancelInvalidObjectPopup} message={message}/>
              :
              null
            }
            {showPractitionerPopup ?
              <AddPractitionerPopup
                cancelPopup={() => setShowPractitionerPopup(false)}
                onSelectPractitioner={handlePractitionerSelect}
                attributeToStructureId={props.targetStructureId || props.structure_Id || null}
              />
              :
              null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(AddUser);
